import { Text } from '@atoms/index';
import texts from '@components/ReferAndEarn/en.json';
import AccordionItem from '@components/Faq/accordionItem';
import { getReferAndEarnFaq } from '@components/ReferAndEarn/helper';

const ReferEarnFaq = () => {
    const faqs = getReferAndEarnFaq();
    return (
        <div className="px-4 py-12 md:px-6 md:py-16 flex flex-col gap-4 md:gap-6 items-center  max-w-[1184px] mx-auto">
            <Text
                content={texts?.ReferAndEarnFaqs}
                className="h5-semibold md:h3-semibold text-primary-500"
            />
            <div className="w-full h-[1px] bg-gray-200" />
            <div className="flex flex-col gap-4">
                {faqs.map((item, index) => (
                    <div key={index}>
                        <AccordionItem
                            question={item.question}
                            answer={item.answer}
                            ansBackgroundColor="bg-secondary-50"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReferEarnFaq;
